export const GET_USERS = 'GET_USERS';
export const GET_CHAT = 'GET_CHAT';
export const SEND_CHAT = 'SEND_CHAT';
export const SEND_CHAT_WITH_FILE = 'SEND_CHAT_WITH_FILE';
export const SAVE_IDS = 'SAVE_IDS';
export const GET_CHAT_COUNTER = 'GET_CHAT_COUNTER';